import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import { BoxedLoader } from "../../BoxedLoader";
import { checkNavigateOrSave } from "src/utils/userMetadata";
import { hasPermission } from "src/utils/handlePermissions";

const LoginAuth0 = (props) => {
  const {
    loginWithRedirect,
    checkAuthorization,
    isInitialized,
    isAuthenticated,
    isLoggedOut,
  } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (isInitialized && !!searchParams.get("code")) {
      checkAuthorization().then((isAuthorized) => {
        if (isAuthorized) {
          const path = hasPermission(
            "dashboard_terms_of_service_privacy_policy"
          )
            ? checkNavigateOrSave()
            : "";
          path == "" ? navigate("/dashboard/main") : navigate(path);
        }
      });
    } else if (!isAuthenticated && isInitialized && !isLoggedOut) {
      loginWithRedirect();
    } else if (isAuthenticated && isInitialized) {
      navigate("/dashboard/main");
    }
  }, [isInitialized, isAuthenticated]);

  return (
    <>
      <div {...props}>
        <BoxedLoader height={"400px"} />
      </div>
    </>
  );
};

export default LoginAuth0;
